import Loading from '../../../Common/Loading';
import { useResultsChartsDataContext } from './hooks/useResultsChartsDataContext';
import { Indicators } from './Indicators';
import { DeathTimeBars } from './DeathTimeBars';
import { DeathTimeDonut } from './DeathTimeDonut';
import { MonthlyDeaths } from './MonthlyDeaths';
import { AnnualDeaths } from './AnnualDeaths';

export const Charts = () => {
    const { isLoading } = useResultsChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Indicators />
            <div className="charts-side-by-side-dashboards">
                <DeathTimeBars />
                <DeathTimeDonut />
            </div>
            <div className="charts-side-by-side-dashboards">
                <MonthlyDeaths />
                <AnnualDeaths />
            </div>
        </>
    );
};
